import './preload';

window.addEventListener("load", () => {
    const monster = document.querySelector<HTMLElement>('.header-logo') || document.querySelector<HTMLElement>('.logo');

    if (!monster) return;

    const setContainerSpacing = () => {
        const monsterRect = monster?.getBoundingClientRect();
        document.documentElement.style.setProperty('--container-spacing', `${monsterRect.left}px`);
    }

    setContainerSpacing();

    window.addEventListener('resize', setContainerSpacing);
});